import useWidth from '../../../../components/Hooks/useWidth';
import LeaveOfflineModeButton from './LeaveOfflineModeButton/LeaveOfflineModeButton';
import OfflineUserMenu from './OfflineUserMenu/OfflineUserMenu';

const OfflineNavigationSidebarBottom = () => {
  const { mobileWidth: isMobile } = useWidth();

  return (
    <>
      <LeaveOfflineModeButton />
      {isMobile && <OfflineUserMenu />}
    </>
  );
};

export default OfflineNavigationSidebarBottom;
